import axios from 'axios';

const instance = axios.create({
    
    // baseURL:'https://localhost:44339/'
     baseURL:'/API/'

    // baseURL:'https://taherabadcico.mazaraat.org/API/'
    // baseURL:'https://admin.fayzetaheri.com/API/'
    // baseURL:'https://betataherabad.mazaraat.org/API/'
});

export default instance;
